import React from 'react'

const Renewal = () => {
    return (
        <div>Renewal</div>
    )
}

export default Renewal